(function () {
  var deferredImageSelector = '[data-ohli-deferred-image]';
  var deferredInstagramSelector = '[data-ohli-deferred-instagram]';

  function materializeImage(image) {
    if (!image || image.dataset.ohliDeferredLoaded === 'true') return;

    image.removeAttribute('hidden');
    var srcset = image.dataset.srcset;
    var src = image.dataset.src;
    if (srcset) image.setAttribute('srcset', srcset);
    if (src) image.setAttribute('src', src);
    image.removeAttribute('data-srcset');
    image.removeAttribute('data-src');
    image.dataset.ohliDeferredLoaded = 'true';
  }

  function materializeWithin(root) {
    if (!root) return;
    if (root.matches && root.matches(deferredImageSelector)) materializeImage(root);
    if (root.querySelectorAll) root.querySelectorAll(deferredImageSelector).forEach(materializeImage);
  }

  var instagramObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              materializeWithin(entry.target);
              instagramObserver.unobserve(entry.target);
            });
          },
          { rootMargin: '400px 0px' }
        )
      : null;

  function instagramSections(root) {
    var sections = [];
    if (root.matches && root.matches(deferredInstagramSelector)) sections.push(root);
    if (root.querySelectorAll) {
      root.querySelectorAll(deferredInstagramSelector).forEach(function (section) {
        sections.push(section);
      });
    }
    return sections;
  }

  function initialize(root) {
    if (!root) return;
    var designMode = Boolean(window.Shopify && window.Shopify.designMode);

    instagramSections(root).forEach(function (section) {
      if (section.dataset.ohliDeferredObserved === 'true') return;
      section.dataset.ohliDeferredObserved = 'true';
      section.querySelectorAll(deferredImageSelector).forEach(function (image) {
        image.removeAttribute('hidden');
      });
      if (designMode || !instagramObserver) materializeWithin(section);
      else instagramObserver.observe(section);
    });

    if (designMode) materializeWithin(root);
  }

  function onSizeChartOpen(event) {
    if (!event.target || typeof event.target.closest !== 'function') return;
    var trigger = event.target.closest('[data-ohli-size-chart-open]');
    if (!trigger) return;
    var opener = trigger.closest('modal-opener');
    var selector = opener && opener.dataset.modal;
    if (!selector) return;

    var modal;
    try {
      modal = document.querySelector(selector);
    } catch (error) {
      return;
    }
    materializeImage(modal && modal.querySelector('[data-ohli-size-chart-guide]'));
  }

  function onSectionUnload(event) {
    if (!instagramObserver) return;
    instagramSections(event.target).forEach(function (section) {
      instagramObserver.unobserve(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize(document);
    });
  } else {
    initialize(document);
  }

  document.addEventListener('click', onSizeChartOpen, true);
  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
  document.addEventListener('shopify:section:unload', onSectionUnload);
})();
